export const REF_OPTIONS: { value: string; label: string }[] = [
  { value: 'vam', label: 'VAM (corsa)' },
  { value: 'vift', label: 'VIFT (corsa)' },
  { value: 'ftp', label: 'FTP (bici)' },
];

export const ABS_UNIT_OPTIONS: string[] = [
  'km/h',
  'min/km',
  'm/s',
  'w',
  'bpm',
  '%fcmax',
  'rpe',
];

export const VOLUME_MODE_OPTIONS: { value: string; label: string }[] = [
  { value: 'distance', label: 'Distanza (m)' },
  { value: 'time', label: 'Tempo (s)' },
];

export const RECOVERY_MODE_OPTIONS: { value: string; label: string }[] = [
  { value: 'time', label: 'Tempo (s)' },
  { value: 'distance', label: 'Distanza (m)' },
];
